import React, { useState, useEffect, useRef } from "react";
import GeneralFeedbackContent, {
  GeneralFeedbackContentStyleConfig,
} from "./GenralFb";
import BugContent from "./Bug";
import FeatureContent from "./Feature";
import { useContext } from "react";
import QuestContext from "../QuestWrapper";
import config from "../../config";
import axios from "axios";
import Loader from "../Login/Loader";
import showToast from "../toast/toastService";
import QuestLabs from "../QuestLabs";
import { Input } from "../Modules/Input";
import Label from "../Modules/Label";
import TextArea from "../Modules/TextArea";
import TopBar from "../Modules/TopBar";
import General, { extractGradientColors } from "../../general";
import { ScreenCapture } from "react-screen-capture";
import Modal from "../Modules/Modal";
import { bug, contact, cross, feature, feedback, thanksPopUpTick } from "./SVG";
import { LabelModule2 } from "../Modules/LabelModule2";
import {
  getColorVariations,
  hexToGlassColor,
} from "../HelpHub/components/helperfunction";
import { adjustColor } from "../../componentsV2/components/feedbackWorkflow/components/ulils";

type BrandTheme = {
  accentColor?: string;
  background?: string;
  borderRadius?: string;
  primaryButton?: string;
  secondaryButton?: string;
  contentColor?: string;
  fontFamily?: string;
  logo?: string;
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
  titleColor?: string;
};
interface QuestThemeData {
  accentColor: string;
  theme: string;
  borderRadius: string;
  buttonColor: string;
  images: string[];
}

type optionType =
  | "ContactUs"
  | "RequestFeature"
  | "ReportBug"
  | "GeneralFeedback";

interface Headers {
  heading?: string;
  subHeading?: string;
}

interface feedbackCompProps {
  userId?: string;
  token?: string;
  questIds?: string[];
  answer?: any;
  setAnswer?: any;
  getAnswers?: any;
  btnTextColor?: string;
  contactUrl?: string;
  isOpen: boolean;
  onClose?: () => void;
  backgroundColor?: string;
  starColor?: string;
  starBorderColor?: string;
  GeneralFeedback?: {
    heading?: string;
    description?: string;
    formHeading?: string;
    formDescription?: string;
    iconUrl?: string;
    styleConfig?: GeneralFeedbackContentStyleConfig;
  };
  Headers?: Headers[] | undefined;
  ReportBug?: {
    heading?: string;
    description?: string;
    formHeading?: string;
    formDescription?: string;
    iconUrl?: string;
    styleConfig?: GeneralFeedbackContentStyleConfig;
  };
  RequestFeature?: {
    heading?: string;
    description?: string;
    formHeading?: string;
    formDescription?: string;
    iconUrl?: string;
    styleConfig?: GeneralFeedbackContentStyleConfig;
  };
  ContactUs?: {
    heading?: string;
    description?: string;
    iconUrl?: string;
  };
  tickBg?: string;
  ratingStyle?: "Star" | "Numbers" | "Smiles";
  uniqueUserId?: string;
  uniqueEmailId?: string;
  descriptions?: Record<optionType, string>;
  backBtn?: boolean;
  iconColor?: string;
  showFooter?: boolean;
  PrimaryButtonText?: string;
  SecondaryButtonText?: string;
  StarSize?: number;
  styleConfig?: {
    Form?: React.CSSProperties;
    Heading?: React.CSSProperties;
    Description?: React.CSSProperties;
    Input?: React.CSSProperties;
    Label?: React.CSSProperties;
    EmailError?: {
      text?: string;
      errorStyle?: React.CSSProperties;
    };
    TopBar?: React.CSSProperties;
    TextArea?: React.CSSProperties;
    PrimaryButton?: React.CSSProperties;
    SecondaryButton?: React.CSSProperties;
    Modal?: React.CSSProperties;
    Footer?: {
      FooterStyle?: React.CSSProperties;
      FooterTextStyle?: React.CSSProperties;
      FooterIcon?: React.CSSProperties;
      FooterText?: string;
      FooterLink?: string;
    };
    listHeading?: React.CSSProperties;
    listDescription?: React.CSSProperties;
    Card?: React.CSSProperties;
    Star?: {
      Style?: React.CSSProperties;
      PrimaryColor?: string;
      SecondaryColor?: string;
      Size?: number;
    };
    ScreenShot?: {
      BorderWidth?: string;
      BorderColor?: string;
      Background?: string;
      ScreenShotBackground?: string;
      CrosshairColor?: string;
    };
    listHover?: {
      background?: string;
      iconBackground?: string;
      iconColor?: string;
      Heading?: string;
      Description?: string;
      IconSize?: string;
      Icon?: React.CSSProperties;
      defaultIconBackground?: string;
    };
    ThanksPopup?: {
      Style?: React.CSSProperties;
      Heading?: React.CSSProperties;
      Description?: React.CSSProperties;
      ShowFooter?: boolean;
      Icon?: React.CSSProperties;
    };
  };
  enableVariation?: boolean;
  offlineFormData: FormDataItem[][];
  BrandTheme?: BrandTheme;
  QuestThemeData?: QuestThemeData;
  sectionConfig?: SectionConfig;
}
interface FormDataItem {
  type?: string;
  title?: string;
  options?: [string];
  actionId?: string;
  question?: string;
  criteriaId?: string;
  required?: boolean;
  isRequired?: boolean;
}
interface FileProp {
  name: string;
  size: number;
  type: string;
  lastModified: number;
  webkitRelativePath: string;
}
interface SectionConfig {
  generalFeedback?: boolean;
  reportBug?: boolean;
  requestFeature?: boolean;
  contactUs?: boolean;
}
const FeedbackWorkflow: React.FC<feedbackCompProps> = ({
  // userId,
  // token,
  // questIds,
  contactUrl,
  isOpen,
  onClose,
  starColor,
  starBorderColor,
  ratingStyle,
  GeneralFeedback,
  ReportBug,
  ContactUs,
  RequestFeature,
  SecondaryButtonText = "Go to home!",
  PrimaryButtonText = "Submit",
  iconColor = "#939393",
  styleConfig = {},
  offlineFormData,
  showFooter = true,
  BrandTheme,
  QuestThemeData,
  Headers,
  sectionConfig,
}) => {
  const [selectedOption, setSelectedOption] = useState<optionType | null>(null);
  const [sectionConfigState, setSectionConfigState] = useState<SectionConfig>(sectionConfig || {
    generalFeedback: true,
    reportBug: true,
    requestFeature: true,
    contactUs: true,
  });
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [submit, setSubmit] = useState<boolean>(false);
  const { apiKey, apiSecret, entityId, featureFlags, apiType, themeConfig } =
    useContext(QuestContext.Context);
  const [cardHovered, setCardHovered] = useState([false, false, false, false]);
  const [answer, setAnswer] = useState<Record<string, string>>({});

  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [screenshot, setScreenshot] = useState<FileProp | null>(null);

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<FileProp | null>(null);
  const [rating, setRating] = useState<number>(0);

  const closeModal = (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    let target = e?.target as Element;
    if (ref?.current?.contains(target)) {
    } else {
      onClose?.();
    }
  };
  const uploadFileToBackend: any = async (file: any) => { };

  const ref = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isVisible == true) {
      document.body.classList.remove("q-feeback-noselect");
    } else {
      document.body.classList.add("q-feeback-noselect");
    }
    return () => {
      document.body.classList.remove("q-feeback-noselect");
    };
  }, [isVisible]);

  useEffect(() => {
    setSectionConfigState(sectionConfig || {
      generalFeedback: true,
      reportBug: true,
      requestFeature: true,
      contactUs: true,
    });
    if (sectionConfig) {
      setSelectedOption(null);
    }
  }, [sectionConfig]);

  let GeneralFunctions = new General("mixpanel", apiType);
  useEffect(() => {
    GeneralFunctions.fireTrackingEvent(
      "quest_feedback_workflow_offline_loaded",
      "feedback_workflow_offline"
    );
  }, []);

  const handleOptionClick = (option: optionType) => {
    if (option === "ContactUs" && contactUrl) {
      window.open(contactUrl, "_blank");
    } else {
      setSelectedOption(option);
      setAnswer({});
    }
  };

  function returnAnswers(index: number) {
    GeneralFunctions.fireTrackingEvent(
      `quest_feedback_workflow_offline${selectedOption}_form_submitted`,
      `feedback_workflow_offline${selectedOption}_form`
    );
    if (Object.keys(answer).length !== 0) {
      const ansArr = offlineFormData[index]?.map((ans: any) => ({
        question: ans?.question || "",
        answer: [answer[ans?.criteriaId] || ""],
        criteriaId: ans?.criteriaId || "",
      }));

      showToast.success({ text: "Thank you for your feedback" });
      setSubmit(true);
      setRating(0);
      setTimeout(() => {
        setSubmit(false);
        setSelectedOption(null);
      }, 4000);
    }
  }

  const handleBackClick = () => {
    GeneralFunctions.fireTrackingEvent(
      `quest_feedback_workflow_offline_${selectedOption}_form_closed`,
      `feedback_workflow_${selectedOption}_form`
    );
    setSelectedOption(null);
  };

  const handleUpdate = (e: any, id: string, j: string, k?: number) => {
    setAnswer({
      ...answer,
      [id]: e?.target?.value || k,
    });
  };
  const handleThanks = () => {
    setSubmit(false);
    setSelectedOption(null);
  };

  const handleRemove = (id: string) => {
    setAnswer({
      ...answer,
      [id]: "",
    });
  };

  const normalInput = (
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean
  ) => {
    return (
      <div className="" key={criteriaId}>
        <LabelModule2
          htmlFor={"normalInput"}
          children={`${question}${required === true ? "*" : ""}`}
          style={{
            borderColor: themeConfig?.borderColor,
            color:
              styleConfig?.Label?.color ||
              styleConfig?.Heading?.color ||
              BrandTheme?.contentColor ||
              themeConfig?.primaryColor,
            ...styleConfig?.Label,
          }}
        />
        <Input
          type="text"
          style={{
            color:
              styleConfig?.Input?.color ||
              styleConfig?.Heading?.color ||
              BrandTheme?.titleColor ||
              themeConfig?.primaryColor,
            ...styleConfig?.Input,
          }}
          placeholder={placeholder}
          value={answer[criteriaId]}
          onChange={(e) => handleUpdate(e, criteriaId, "")}
          required={required}
        />
      </div>
    );
  };
  const emailInput = (
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean
  ) => {
    return (
      <div className="" key={criteriaId}>
        <LabelModule2
          htmlFor={"normalInput"}
          children={`${question}${required === true ? "*" : ""}`}
          style={{
            color:
              styleConfig?.Label?.color ||
              styleConfig?.Heading?.color ||
              BrandTheme?.contentColor ||
              themeConfig?.primaryColor,
            ...styleConfig?.Label,
          }}
        />
        <Input
          type="email"
          style={{
            borderColor: themeConfig?.borderColor,
            color:
              styleConfig?.Input?.color ||
              styleConfig?.Heading?.color ||
              BrandTheme?.titleColor ||
              themeConfig?.primaryColor,
            ...styleConfig?.Input,
          }}
          placeholder={placeholder}
          value={answer[criteriaId]}
          onChange={(e) => handleUpdate(e, criteriaId, "")}
          emailtext={
            styleConfig?.EmailError?.text == undefined
              ? "This is not a valid email"
              : styleConfig?.EmailError?.text
          }
          emailErrorStyle={styleConfig?.EmailError?.errorStyle}
          required={required}
        />

        {/* {isValidEmail(answer[criteriaId]) && (
          <div className="q-input-email-checks">This is not a valid email</div>
        )} */}
      </div>
    );
  };

  const normalInput2 = (
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean
  ) => {
    return (
      <div className="" key={criteriaId}>
        <LabelModule2
          htmlFor={"normalInput"}
          children={`${question}${required === true ? "*" : ""}`}
          style={{
            color:
              styleConfig?.Label?.color ||
              styleConfig?.Heading?.color ||
              BrandTheme?.contentColor ||
              themeConfig?.primaryColor,
            ...styleConfig?.Label,
          }}
        />
        <TextArea
          onChange={(e) => handleUpdate(e, criteriaId, "")}
          value={answer[criteriaId]}
          placeholder={placeholder}
          style={{
            borderColor: themeConfig?.borderColor,
            color:
              styleConfig?.TextArea?.color ||
              styleConfig?.Heading?.color ||
              BrandTheme?.titleColor ||
              themeConfig?.primaryColor,
            ...styleConfig?.TextArea,
          }}
          required={required}
        />
      </div>
    );
  };

  if (
    featureFlags[config?.FLAG_CONSTRAINTS?.FeedbackWorkflowFlag]?.isEnabled ==
    false
  ) {
    return <div></div>;
  }

  const handleScreenCapture = async (capture: any) => {
    setIsVisible(true);
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const time = hours + ":" + minutes + ":" + seconds;
    let fileName = "screenshot" + time + ".jpg"; // Ensure file name has proper format

    try {
      const response = await axios.get(capture, { responseType: "blob" });

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "image/jpeg" });

      // Create a File object from the Blob
      const file = new File([blob], fileName, { type: "image/jpeg" });

      // If you need to update state with the new file object
      setScreenshot(file);
    } catch (error) {
      console.error("An error occurred while fetching the image:", error);
    }
  };

  useEffect(() => {
    styleConfig?.ScreenShot?.BorderColor &&
      document.documentElement.style.setProperty(
        "--q-screenshot-border-color",
        styleConfig?.ScreenShot?.BorderColor
      );
    styleConfig?.ScreenShot?.BorderWidth &&
      document.documentElement.style.setProperty(
        "--q-screenshot-border-width",
        styleConfig?.ScreenShot?.BorderWidth
      );
    styleConfig?.ScreenShot?.Background &&
      document.documentElement.style.setProperty(
        "--q-screenshot-container-background",
        styleConfig?.ScreenShot?.Background
      );
    styleConfig?.ScreenShot?.ScreenShotBackground &&
      document.documentElement.style.setProperty(
        "--q-screenshot-inner-container-background",
        styleConfig?.ScreenShot?.ScreenShotBackground
      );
    styleConfig?.ScreenShot?.CrosshairColor &&
      document.documentElement.style.setProperty(
        "--q-screenshot-crosshair-color",
        styleConfig?.ScreenShot?.CrosshairColor
      );
  }, [styleConfig?.ScreenShot]);

  let color = extractGradientColors(BrandTheme?.primaryColor || QuestThemeData?.accentColor);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose || (() => { })}
      style={{ padding: 0, background: "transparent", ...styleConfig?.Modal }}
    >
      <ScreenCapture onEndCapture={handleScreenCapture}>
        {({ onStartCapture }: any) => (
          <div
            className="q_modal_overlay"
            onClick={(e) => closeModal(e)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: !isVisible ? "transparent" : "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: isVisible ? 1 : 0,
            }}
          >
            {showLoader && <Loader />}

            {!submit && (
              <div
                className="q_modal"
                ref={ref}
                id="modal_box"
                style={{
                  padding: 0,
                  background: "transparent",
                  opacity: isVisible ? 1 : 0,
                  ...styleConfig?.Modal,
                  borderRadius:
                    styleConfig?.Form?.borderRadius ||
                    QuestThemeData?.borderRadius ||
                    BrandTheme?.borderRadius,
                }}
              >
                <div
                  className="q-fw-div"
                  style={{
                    background:
                      styleConfig?.Form?.backgroundColor ||
                      BrandTheme?.background ||
                      themeConfig?.backgroundColor,
                    height: styleConfig?.Form?.height || "auto",
                    borderRadius:
                      styleConfig?.Form?.borderRadius ||
                      QuestThemeData?.borderRadius ||
                      BrandTheme?.borderRadius,
                    fontFamily:
                      BrandTheme?.fontFamily ||
                      themeConfig?.fontFamily ||
                      "'Figtree', sans-serif",
                    ...styleConfig?.Form,
                  }}
                  id="disabledClick"
                >
                  {selectedOption && !submit ? (
                    <div>
                      <TopBar
                        style={{
                          topbarStyle: styleConfig?.TopBar,
                          headingStyle: {
                            color:
                              styleConfig?.Heading?.color ||
                              BrandTheme?.titleColor ||
                              themeConfig?.primaryColor,
                            ...styleConfig?.Heading,
                          },
                          descriptionStyle: {
                            color:
                              styleConfig?.Description?.color ||
                              BrandTheme?.contentColor ||
                              themeConfig?.secondaryColor,
                            ...styleConfig?.Description,
                          },
                        }}
                        description={
                          selectedOption == "ContactUs"
                            ? Array.isArray(Headers)
                              ? Headers[3]?.subHeading
                              : ContactUs?.description ||
                              "Invite other admins and moderators"
                            : selectedOption == "RequestFeature"
                              ? Array.isArray(Headers)
                                ? Headers[2]?.subHeading
                                : RequestFeature?.formDescription ||
                                "How can we make it better"
                              : selectedOption == "ReportBug"
                                ? Array.isArray(Headers)
                                  ? Headers[1]?.subHeading
                                  : ReportBug?.formDescription ||
                                  "Describe your issue"
                                : Array.isArray(Headers)
                                  ? Headers[0]?.subHeading
                                  : GeneralFeedback?.formDescription ||
                                  "Give general feedback on this page"
                        }
                        heading={
                          selectedOption == "ContactUs"
                            ? Array.isArray(Headers)
                              ? Headers[3]?.heading
                              : ContactUs?.heading || "Contact us"
                            : selectedOption == "RequestFeature"
                              ? Array.isArray(Headers)
                                ? Headers[2]?.heading
                                : RequestFeature?.formHeading ||
                                "Request a Feature"
                              : selectedOption == "ReportBug"
                                ? Array.isArray(Headers)
                                  ? Headers[1]?.heading
                                  : ReportBug?.formHeading || "Report a Bug"
                                : Array.isArray(Headers)
                                  ? Headers[0]?.heading
                                  : GeneralFeedback?.formHeading || "General Feedback"
                        }
                        iconColor={iconColor}
                        onClose={handleBackClick}
                      />
                      <div style={{ padding: "20px" }}>
                        {selectedOption === "GeneralFeedback" && (
                          <GeneralFeedbackContent
                            starColor={starColor}
                            handleSubmit={() => returnAnswers(0)}
                            handleUpdate={handleUpdate}
                            formdata={offlineFormData[0]}
                            normalInput={normalInput}
                            emailInput={emailInput}
                            normalInput2={normalInput2}
                            starBorderColor={starBorderColor}
                            answer={answer}
                            handleRemove={handleRemove}
                            ratingStyle={ratingStyle}
                            iconColor={iconColor}
                            buttonStyle={{
                              background:
                                styleConfig?.PrimaryButton?.background ||
                                QuestThemeData?.buttonColor ||
                                QuestThemeData?.accentColor ||
                                BrandTheme?.primaryColor ||
                                BrandTheme?.primaryButton ||
                                themeConfig?.buttonColor,
                              borderColor:
                                styleConfig?.PrimaryButton?.borderColor ||
                                QuestThemeData?.buttonColor ||
                                QuestThemeData?.accentColor,
                              ...styleConfig?.PrimaryButton,
                            }}
                            PrimaryButtonText={PrimaryButtonText}
                            StarStyle={styleConfig?.Star}
                            labelStyle={{
                              ...styleConfig?.Label,
                              color:
                                styleConfig?.Label?.color ||
                                styleConfig?.Heading?.color ||
                                BrandTheme?.contentColor ||
                                themeConfig?.primaryColor,
                            }}
                            isVisible={isVisible}
                            setIsVisible={setIsVisible}
                            screenshot={screenshot}
                            setScreenshot={setScreenshot}
                            onStartCapture={onStartCapture}
                            uploadFileToBackend={uploadFileToBackend}
                            inputRef={inputRef}
                            file={file}
                            setFile={setFile}
                            styleConfig={GeneralFeedback?.styleConfig}
                            rating={rating}
                            setRating={setRating}
                          />
                        )}
                        {selectedOption === "ReportBug" && (
                          <BugContent
                            handleSubmit={() => returnAnswers(1)}
                            handleUpdate={handleUpdate}
                            formdata={offlineFormData[1]}
                            answer={answer}
                            normalInput={normalInput}
                            normalInput2={normalInput2}
                            emailInput={emailInput}
                            handleRemove={handleRemove}
                            PrimaryButtonText={PrimaryButtonText}
                            buttonStyle={{
                              background:
                                styleConfig?.PrimaryButton?.background ||
                                QuestThemeData?.buttonColor ||
                                QuestThemeData?.accentColor ||
                                BrandTheme?.primaryColor ||
                                BrandTheme?.primaryButton ||
                                themeConfig?.buttonColor,
                              borderColor:
                                styleConfig?.PrimaryButton?.borderColor ||
                                QuestThemeData?.buttonColor ||
                                QuestThemeData?.accentColor,
                              ...styleConfig?.PrimaryButton,
                            }}
                            isVisible={isVisible}
                            setIsVisible={setIsVisible}
                            screenshot={screenshot}
                            setScreenshot={setScreenshot}
                            onStartCapture={onStartCapture}
                            uploadFileToBackend={uploadFileToBackend}
                            inputRef={inputRef}
                            file={file}
                            setFile={setFile}
                            styleConfig={ReportBug?.styleConfig}
                            BrandTheme={BrandTheme}
                            rating={rating}
                            setRating={setRating}
                          />
                        )}
                        {selectedOption === "RequestFeature" && (
                          <FeatureContent
                            handleSubmit={() => returnAnswers(2)}
                            handleUpdate={handleUpdate}
                            formdata={offlineFormData[2]}
                            normalInput={normalInput}
                            normalInput2={normalInput2}
                            emailInput={emailInput}
                            answer={answer}
                            handleRemove={handleRemove}
                            PrimaryButtonText={PrimaryButtonText}
                            buttonStyle={{
                              background:
                                styleConfig?.PrimaryButton?.background ||
                                QuestThemeData?.buttonColor ||
                                QuestThemeData?.accentColor ||
                                BrandTheme?.primaryColor ||
                                BrandTheme?.primaryButton ||
                                themeConfig?.buttonColor,
                              borderColor:
                                styleConfig?.PrimaryButton?.borderColor ||
                                QuestThemeData?.buttonColor ||
                                QuestThemeData?.accentColor,
                              ...styleConfig?.PrimaryButton,
                            }}
                            isVisible={isVisible}
                            setIsVisible={setIsVisible}
                            screenshot={screenshot}
                            setScreenshot={setScreenshot}
                            onStartCapture={onStartCapture}
                            uploadFileToBackend={uploadFileToBackend}
                            inputRef={inputRef}
                            file={file}
                            setFile={setFile}
                            styleConfig={RequestFeature?.styleConfig}
                            BrandTheme={BrandTheme}
                            rating={rating}
                            setRating={setRating}
                          />
                        )}
                        {selectedOption === "ContactUs" && <div></div>}
                      </div>
                      {showFooter && (
                        <QuestLabs
                          style={{
                            ...{
                              background:
                                styleConfig?.Footer?.FooterStyle
                                  ?.backgroundColor ||
                                styleConfig?.Form?.backgroundColor ||
                                styleConfig?.Form?.background ||
                                BrandTheme?.background ||
                                themeConfig?.backgroundColor,
                            },
                            ...styleConfig?.Footer?.FooterStyle,
                          }}
                          textStyle={styleConfig?.Footer?.FooterTextStyle}
                          iconStyle={styleConfig?.Footer?.FooterIcon}
                          text={styleConfig?.Footer?.FooterText}
                          link={styleConfig?.Footer?.FooterLink}
                        />
                      )}
                    </div>
                  ) : !submit ? (
                    <div>
                      <div className="q-fw-crossBtn">
                        <div onClick={() => onClose?.()}>
                          {cross(iconColor)}
                        </div>
                      </div>
                      <div className="q-fw-content-box">
                        {sectionConfigState?.generalFeedback && <div
                          onClick={() => {
                            GeneralFunctions.fireTrackingEvent(
                              "quest_feedback_workflow_general_feedback_clicked",
                              "feedback_workflow_general_feedback"
                            );
                            handleOptionClick("GeneralFeedback");
                          }}
                          className="q-hover q-fw-cards"
                          onMouseEnter={() =>
                            setCardHovered([true, false, false, false])
                          }
                          onMouseLeave={() =>
                            setCardHovered([false, false, false, false])
                          }
                          style={{
                            background: cardHovered[0]
                              ? styleConfig?.listHover?.background ||
                              // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                              "#FBFBFB"
                              : "transparent",
                            borderRadius: "8px",
                            ...styleConfig?.Card,
                          }}
                        >
                          <div
                            className="q_feedback_icon"
                            style={{
                              background: cardHovered[0]
                                ? styleConfig?.listHover?.iconBackground ||
                                hexToGlassColor(
                                  color,
                                  0.1
                                ) ||
                                "#F4EBFF"
                                : "#FBFBFB",
                              ...styleConfig?.listHover?.Icon,
                            }}
                          >
                            {GeneralFeedback?.iconUrl ? (
                              <img
                                className="q_feedback_icon_imgurl"
                                src={GeneralFeedback?.iconUrl}
                              />
                            ) : (
                              feedback(
                                cardHovered[0]
                                  ? styleConfig?.listHover?.iconColor ||
                                  color ||
                                  "#9035FF"
                                  : iconColor,
                                styleConfig?.listHover?.IconSize
                              )
                            )}
                          </div>
                          <div>
                            <div
                              className="q-fw-tab-heading"
                              style={{
                                color: cardHovered[0]
                                  ? styleConfig?.listHover?.Heading ||
                                  styleConfig?.listHeading?.color ||
                                  styleConfig?.Heading?.color ||
                                  BrandTheme?.titleColor ||
                                  themeConfig?.primaryColor
                                  : styleConfig?.listHeading?.color ||
                                  styleConfig?.Heading?.color ||
                                  BrandTheme?.titleColor ||
                                  themeConfig?.primaryColor,
                                ...styleConfig?.listHeading,
                              }}
                            >
                              {GeneralFeedback?.heading || Headers?.[0]?.heading || "General Feedback"}
                            </div>
                            <div
                              className="q-fw-tab-description"
                              style={{
                                color: cardHovered[0]
                                  ? styleConfig?.listHover?.Description ||
                                  styleConfig?.listDescription?.color ||
                                  styleConfig?.Description?.color ||
                                  BrandTheme?.contentColor ||
                                  themeConfig?.secondaryColor
                                  : styleConfig?.listDescription?.color ||
                                  styleConfig?.Description?.color ||
                                  BrandTheme?.contentColor ||
                                  themeConfig?.secondaryColor,
                                ...styleConfig?.listDescription,
                              }}
                            >
                              {GeneralFeedback?.description || Headers?.[0]?.subHeading ||
                                "Give general feedback on this page"}
                            </div>
                          </div>
                        </div>}

                        {sectionConfigState?.reportBug && <div
                          onClick={() => {
                            GeneralFunctions.fireTrackingEvent(
                              "quest_feedback_workflow_report_bug_clicked",
                              "feedback_workflow_report_bug"
                            );
                            handleOptionClick("ReportBug");
                          }}
                          className="q-hover q-fw-cards"
                          onMouseEnter={() =>
                            setCardHovered([false, true, false, false])
                          }
                          onMouseLeave={() =>
                            setCardHovered([false, false, false, false])
                          }
                          style={{
                            background: cardHovered[1]
                              ? styleConfig?.listHover?.background ||
                              // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                              "#FBFBFB"
                              : "transparent",
                            borderRadius: "8px",
                            ...styleConfig?.Card,
                          }}
                        >
                          <div
                            className="q_feedback_icon"
                            style={{
                              background: cardHovered[1]
                                ? styleConfig?.listHover?.iconBackground ||
                                hexToGlassColor(
                                  color,
                                  0.1
                                ) ||
                                "#F4EBFF"
                                : "#FBFBFB",
                              ...styleConfig?.listHover?.Icon,
                            }}
                          >
                            {ReportBug?.iconUrl ? (
                              <img
                                className="q_feedback_icon_imgurl"
                                src={ReportBug?.iconUrl}
                              />
                            ) : (
                              bug(
                                cardHovered[1]
                                  ? styleConfig?.listHover?.iconColor ||
                                  color ||
                                  "#9035FF"
                                  : iconColor,
                                styleConfig?.listHover?.IconSize
                              )
                            )}
                          </div>
                          <div>
                            <div>
                              <div
                                className="q-fw-tab-heading"
                                style={{
                                  color: cardHovered[1]
                                    ? styleConfig?.listHover?.Heading ||
                                    styleConfig?.listHeading?.color ||
                                    styleConfig?.Heading?.color ||
                                    BrandTheme?.titleColor ||
                                    themeConfig?.primaryColor
                                    : styleConfig?.listHeading?.color ||
                                    styleConfig?.Heading?.color ||
                                    BrandTheme?.titleColor ||
                                    themeConfig?.primaryColor,
                                  ...styleConfig?.listHeading,
                                }}
                              >
                                {ReportBug?.heading || Headers?.[1]?.heading || "Report a Bug"}
                              </div>
                            </div>
                            <div>
                              <div
                                className="q-fw-tab-description"
                                style={{
                                  color: cardHovered[1]
                                    ? styleConfig?.listHover?.Description ||
                                    styleConfig?.listDescription?.color ||
                                    styleConfig?.Description?.color ||
                                    BrandTheme?.contentColor ||
                                    themeConfig?.secondaryColor
                                    : styleConfig?.listDescription?.color ||
                                    styleConfig?.Description?.color ||
                                    BrandTheme?.contentColor ||
                                    themeConfig?.secondaryColor,
                                  ...styleConfig?.listDescription,
                                }}
                              >
                                {ReportBug?.description || Headers?.[1]?.subHeading ||
                                  "Let us know what's broken"}
                              </div>
                            </div>
                          </div>
                        </div>}

                        {sectionConfigState?.requestFeature && <div
                          onClick={() => {
                            GeneralFunctions.fireTrackingEvent(
                              "quest_feedback_workflow_request_feature_clicked",
                              "feedback_workflow_request_feature"
                            );
                            handleOptionClick("RequestFeature");
                          }}
                          className="q-hover q-fw-cards"
                          onMouseEnter={() =>
                            setCardHovered([false, false, true, false])
                          }
                          onMouseLeave={() =>
                            setCardHovered([false, false, false, false])
                          }
                          style={{
                            background: cardHovered[2]
                              ? styleConfig?.listHover?.background ||
                              // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                              "#FBFBFB"
                              : "transparent",
                            borderRadius: "8px",
                            ...styleConfig?.Card,
                          }}
                        >
                          <div
                            className="q_feedback_icon"
                            style={{
                              background: cardHovered[2]
                                ? styleConfig?.listHover?.iconBackground ||
                                hexToGlassColor(color, 0.1) ||
                                "#F4EBFF"
                                : "#FBFBFB",
                              ...styleConfig?.listHover?.Icon,
                            }}
                          >
                            {RequestFeature?.iconUrl ? (
                              <img
                                className="q_feedback_icon_imgurl"
                                src={RequestFeature?.iconUrl}
                              />
                            ) : (
                              feature(
                                cardHovered[2]
                                  ? styleConfig?.listHover?.iconColor ||
                                  color ||
                                  "#9035FF"
                                  : iconColor,
                                styleConfig?.listHover?.IconSize
                              )
                            )}
                          </div>
                          <div>
                            <div>
                              <div
                                className="q-fw-tab-heading"
                                style={{
                                  color: cardHovered[2]
                                    ? styleConfig?.listHover?.Heading ||
                                    styleConfig?.listHeading?.color ||
                                    styleConfig?.Heading?.color ||
                                    BrandTheme?.titleColor ||
                                    themeConfig?.primaryColor
                                    : styleConfig?.listHeading?.color ||
                                    styleConfig?.Heading?.color ||
                                    BrandTheme?.titleColor ||
                                    themeConfig?.primaryColor,
                                  ...styleConfig?.listHeading,
                                }}
                              >
                                {RequestFeature?.heading || Headers?.[2]?.heading || "Request a Feature"}
                              </div>
                            </div>
                            <div>
                              <div
                                className="q-fw-tab-description"
                                style={{
                                  color: cardHovered[2]
                                    ? styleConfig?.listHover?.Description ||
                                    styleConfig?.listDescription?.color ||
                                    styleConfig?.Description?.color ||
                                    BrandTheme?.contentColor ||
                                    themeConfig?.secondaryColor
                                    : styleConfig?.listDescription?.color ||
                                    styleConfig?.Description?.color ||
                                    BrandTheme?.contentColor ||
                                    themeConfig?.secondaryColor,
                                  ...styleConfig?.listDescription,
                                }}
                              >
                                {RequestFeature?.description || Headers?.[2]?.subHeading || "Tell us how we can improve"}
                              </div>
                            </div>
                          </div>
                        </div>}

                        {sectionConfigState?.contactUs && <div
                          onClick={() => {
                            GeneralFunctions.fireTrackingEvent(
                              "quest_feedback_workflow_contactus_clicked",
                              "feedback_workflow_contactus"
                            );
                            handleOptionClick("ContactUs");
                          }}
                          className="q-hover q-fw-cards"
                          onMouseEnter={() =>
                            setCardHovered([false, false, false, true])
                          }
                          onMouseLeave={() =>
                            setCardHovered([false, false, false, false])
                          }
                          style={{
                            background: cardHovered[3]
                              ? styleConfig?.listHover?.background ||
                              // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                              "#FBFBFB"
                              : "transparent",
                            borderRadius: "8px",
                            ...styleConfig?.Card,
                          }}
                        >
                          <div
                            className="q_feedback_icon"
                            style={{
                              background: cardHovered[3]
                                ? styleConfig?.listHover?.iconBackground ||
                                hexToGlassColor(
                                  color,
                                  0.1
                                ) ||
                                "#F4EBFF"
                                : "#FBFBFB",
                              ...styleConfig?.listHover?.Icon,
                            }}
                          >
                            {ContactUs?.iconUrl ? (
                              <img
                                className="q_feedback_icon_imgurl"
                                src={ContactUs?.iconUrl}
                              />
                            ) : (
                              contact(
                                cardHovered[3]
                                  ? styleConfig?.listHover?.iconColor ||
                                  color ||
                                  "#9035FF"
                                  : iconColor,
                                styleConfig?.listHover?.IconSize
                              )
                            )}
                          </div>
                          <div>
                            <div>
                              <div
                                className="q-fw-tab-heading"
                                style={{
                                  color: cardHovered[3]
                                    ? styleConfig?.listHover?.Heading ||
                                    styleConfig?.listHeading?.color ||
                                    styleConfig?.Heading?.color ||
                                    BrandTheme?.titleColor ||
                                    themeConfig?.primaryColor
                                    : styleConfig?.listHeading?.color ||
                                    styleConfig?.Heading?.color ||
                                    BrandTheme?.titleColor ||
                                    themeConfig?.primaryColor,
                                  ...styleConfig?.listHeading,
                                }}
                              >
                                {ContactUs?.heading || Headers?.[3]?.heading || "Contact us"}
                              </div>
                            </div>
                            <div>
                              <div
                                style={{
                                  color: cardHovered[3]
                                    ? styleConfig?.listHover?.Description ||
                                    styleConfig?.listDescription?.color ||
                                    styleConfig?.Description?.color ||
                                    BrandTheme?.contentColor ||
                                    themeConfig?.secondaryColor
                                    : styleConfig?.listDescription?.color ||
                                    styleConfig?.Description?.color ||
                                    BrandTheme?.contentColor ||
                                    themeConfig?.secondaryColor,
                                  ...styleConfig?.listDescription,
                                }}
                                className="q-fw-tab-description"
                              >
                                {ContactUs?.description || Headers?.[3]?.subHeading || "Invite other admins and moderators"}
                              </div>
                            </div>
                          </div>
                        </div>}
                      </div>
                      <div>
                        {showFooter && (
                          <QuestLabs
                            style={{
                              ...{
                                background:
                                  styleConfig?.Footer?.FooterStyle
                                    ?.backgroundColor ||
                                  styleConfig?.Form?.backgroundColor ||
                                  styleConfig?.Form?.background ||
                                  BrandTheme?.background ||
                                  themeConfig?.backgroundColor,
                              },
                              ...styleConfig?.Footer?.FooterStyle,
                            }}
                            textStyle={styleConfig?.Footer?.FooterTextStyle}
                            iconStyle={styleConfig?.Footer?.FooterIcon}
                            text={styleConfig?.Footer?.FooterText}
                            link={styleConfig?.Footer?.FooterLink}
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}

            {submit && (
              <div
                className="q-fw-div"
                style={{
                  background:
                    styleConfig?.ThanksPopup?.Style?.background ||
                    styleConfig?.Form?.backgroundColor ||
                    BrandTheme?.background ||
                    themeConfig?.backgroundColor,
                  height:
                    styleConfig?.ThanksPopup?.Style?.height ||
                    styleConfig?.Form?.height ||
                    "auto",
                  fontFamily: themeConfig.fontFamily || "'Figtree', sans-serif",
                  borderRadius:
                    styleConfig?.Form?.borderRadius ||
                    QuestThemeData?.borderRadius ||
                    BrandTheme?.borderRadius,
                  ...styleConfig?.ThanksPopup?.Style,
                }}
                id="disabledClick"
              >
                <div className="q_submit_cross_icon" onClick={handleThanks}>
                  {cross(iconColor, handleBackClick)}
                </div>
                <div className="q-fw-thanks">
                  <div>
                    <div className="q-svg-thanks">{thanksPopUpTick(color)}</div>
                    <div className="q_fw_submit_box">
                      <div className="q_feedback_text_submitted">
                        <div
                          className="q_feedback_text_cont"
                          style={{
                            color:
                              styleConfig?.Heading?.color ||
                              BrandTheme?.titleColor ||
                              themeConfig?.primaryColor,
                            ...styleConfig?.ThanksPopup?.Heading,
                          }}
                        >
                          Feedback Submitted
                        </div>
                        <div
                          className="q_fw_submit_desc"
                          style={{
                            color:
                              styleConfig?.Description?.color ||
                              BrandTheme?.contentColor ||
                              themeConfig?.secondaryColor,
                            ...styleConfig?.ThanksPopup?.Description,
                          }}
                        >
                          Thanks for submitting your feedback with us. We
                          appreciate your review and will assure you to surely
                          consider them
                        </div>
                      </div>
                      <div
                        className="q_fw_submit_back"
                        style={{
                          background:
                            styleConfig?.SecondaryButton?.background ||
                            BrandTheme?.secondaryButton,
                          ...styleConfig?.SecondaryButton,
                        }}
                      >
                        {SecondaryButtonText}
                      </div>
                    </div>
                  </div>
                </div>
                {(styleConfig?.ThanksPopup?.ShowFooter || showFooter) && (
                  <QuestLabs
                    style={{
                      ...{
                        background:
                          styleConfig?.Footer?.FooterStyle?.backgroundColor ||
                          styleConfig?.Form?.backgroundColor ||
                          styleConfig?.Form?.background ||
                          BrandTheme?.background ||
                          themeConfig?.backgroundColor,
                      },
                      ...styleConfig?.Footer?.FooterStyle,
                    }}
                    textStyle={styleConfig?.Footer?.FooterTextStyle}
                    iconStyle={styleConfig?.Footer?.FooterIcon}
                    text={styleConfig?.Footer?.FooterText}
                    link={styleConfig?.Footer?.FooterLink}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </ScreenCapture>
    </Modal>
  );
};

export default FeedbackWorkflow;
